module.exports = __webpack_public_path__ + "img/unidad-3.aff3739b.png";